<template>
  <svg
    :class="{ coloured }"
    id="Tour_Pass_icon"
    data-name="Tour Pass icon"
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="33"
    viewBox="0 0 33 33"
  >
    <rect
      id="Rectangle_1650"
      data-name="Rectangle 1650"
      width="33"
      height="33"
      fill="none"
    />
    <path
      id="Path_2111"
      data-name="Path 2111"
      d="M24.633,4.209l-.262.458a1.577,1.577,0,0,1-2.154.587,1.593,1.593,0,0,1-.583-2.166L21.9,2.63,17.334,0,14.591,4.807,11.822.016,7.275,2.67l.264.457A1.593,1.593,0,0,1,6.967,5.3a1.576,1.576,0,0,1-2.156-.574l-.264-.457L0,6.92,8.982,22.457l4.534-2.647-.257-.456a1.594,1.594,0,0,1,.577-2.152,1.577,1.577,0,0,1,2.147.561l.015.024a1.578,1.578,0,0,1,0,1.557l-.253.457L20.3,22.427l8.9-15.587ZM13.308,16.289A2.658,2.658,0,0,0,12.133,19.4L9.364,21.013,1.438,7.3,4.212,5.683a2.634,2.634,0,0,0,4.455-2.6L11.441,1.46l2.546,4.405h0l5.38,9.306L16.577,16.8a2.634,2.634,0,0,0-3.269-.511m3.819,3.091a2.613,2.613,0,0,0-.016-1.669L20.8,15.554,15.2,5.862l2.521-4.42,2.783,1.606a2.653,2.653,0,0,0,1.188,3.122,2.624,2.624,0,0,0,3.281-.544l2.783,1.6-7.85,13.754Z"
      transform="translate(1.123 4.491)"
      fill="#2d323c"
    />
    <path
      class="left"
      id="Path_2384"
      data-name="Path 2384"
      d="M13.151,16.129a2.658,2.658,0,0,0-1.175,3.107L9.206,20.854,1.28,7.144,4.055,5.523a2.634,2.634,0,0,0,4.455-2.6L11.284,1.3,13.83,5.705h0l5.38,9.306-2.79,1.628a2.634,2.634,0,0,0-3.269-.511"
      transform="translate(1.28 4.651)"
      fill="#d2d7dc"
    />
    <rect
      id="Rectangle_1503"
      data-name="Rectangle 1503"
      width="0.971"
      height="5.825"
      transform="translate(7.749 14.549) rotate(-30.155)"
      fill="#2d323c"
    />
    <rect
      id="Rectangle_1504"
      data-name="Rectangle 1504"
      width="0.971"
      height="5.825"
      transform="matrix(0.865, -0.502, 0.502, 0.865, 11.432, 12.357)"
      fill="#2d323c"
    />
    <path
      class="right"
      id="Path_2385"
      data-name="Path 2385"
      d="M15.463,19.222a2.613,2.613,0,0,0-.016-1.669L19.141,15.4,13.539,5.7l2.521-4.42L18.843,2.89a2.653,2.653,0,0,0,1.188,3.122,2.624,2.624,0,0,0,3.281-.544l2.783,1.6-7.85,13.754Z"
      transform="translate(2.786 4.649)"
      fill="#e0bd78"
    />
  </svg>
</template>

<script>
export default {
  name: 'Events',
  props: {
    coloured: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.coloured {
  .left {
    fill: #d2d7dc;
  }
  .right {
    fill: #e0bd78;
  }
}
.left {
  fill: transparent;
}
.right {
  fill: transparent;
}
</style>
